import {
  BetaTag,
  Card,
  CardErrorBoundaryWithSpinfinity,
  Typography,
} from 'components';
import BodyContainer from './BodyContainer';
import CardReferences from './CardReferences';
import styles from './GutXAxisCard.module.css';
import OrganList from './OrganList';

export default function GutXAxisCard() {
  return (
    <CardErrorBoundaryWithSpinfinity cardName='GutXAxisCard'>
      <Card>
        <div className={styles.cardContainer}>
          <div className='flex align-items-center gap-1'>
            <Typography variant='body-m'>Your gut body connections</Typography>
            <BetaTag />
          </div>
          <Typography variant='body-xs' color='grey'>
            Discover connections between your health and your microbiome report
          </Typography>
          <BodyContainer />
          <CardReferences />
          <OrganList />
        </div>
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
}
